export default {
  discount_types: {
    cashback: 'Points de fidélité',
    promo_code: 'Code promo',
  },
  input: {
    label: '{{cashbackLabel}} ou {{promoCodeLabel}}',
    placeholder: 'Code promo',
  },
  buttons: {
    apply: 'Appliquer',
    remove: 'Retirer',
  },
  feedback: {
    login:
      "<highlight>Connectez-vous</highlight> pour utiliser ce promo afin que nous puissions vérifier que vous ne l'avez pas déjà utilisé. Connectez-vous et réessayez.",
    usage_threshold: 'Le montant minimum du panier pour ce promo est (hors frais de livraison)',
    promo_code_added: 'Code promo appliqué avec succès',
  },
};
